export default "__VITE_ASSET__8b217fd9__"